// extracted by mini-css-extract-plugin
export var active = "_2h-d";
export var blink = "_2h-e";
export var container = "_2h-5";
export var controls = "_2h-0";
export var controlsRight = "_2h-1";
export var fakeCursor = "_2h-c";
export var hidden = "_2h-b";
export var quillContainerSmall = "_2h-7";
export var quillEditor = "_2h-6";
export var quillEditorSmall = "_2h-8";
export var quillFormatButtons = "_2h-a";
export var quillToolbar = "_2h-9";
export var removePadding = "_2h-2";
export var state = "_2h-3";
export var stateTitle = "_2h-4";